import { render, staticRenderFns } from "./Digitals.vue?vue&type=template&id=b8f53e44&scoped=true&"
import script from "./Digitals.vue?vue&type=script&lang=js&"
export * from "./Digitals.vue?vue&type=script&lang=js&"
import style0 from "./Digitals.vue?vue&type=style&index=0&id=b8f53e44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f53e44",
  null
  
)

export default component.exports